import apiKeyUIStore from './apiKeyUIStore.js';
import apiKeyDataStore from './apiKeyDataStore.js';

export default {
  modules: {
    ui: apiKeyUIStore,
    data: apiKeyDataStore,
  },
};
